import AddBeneficiaryError from './AddBeneficiaryError';
class InvalidFormatCurp extends AddBeneficiaryError {
    constructor(options) {
        super('CURP does not match the correct format', options);
    }
}
export default InvalidFormatCurp;
